import { forwardRef, type SVGProps } from 'react';

export type FigmaPlusIconProps = {} & Omit<SVGProps<SVGSVGElement>, 'css'>;

export const FigmaPlusIcon = forwardRef<SVGSVGElement, FigmaPlusIconProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="none" viewBox="0 0 16 16">
    <path
      clipRule="evenodd"
      d="M7.5 7.5V2.5H8.5V7.5H13.5V8.5H8.5V13.5H7.5V8.5H2.5V7.5H7.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
));

FigmaPlusIcon.displayName = 'FigmaPlusIcon';
